import { render, staticRenderFns } from "./SpecialBiwako202410.vue?vue&type=template&id=cf66dac2&scoped=true"
import script from "./SpecialBiwako202410.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako202410.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako202410.vue?vue&type=style&index=0&id=cf66dac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf66dac2",
  null
  
)

export default component.exports